function setupAdformBidding() {
  let biddingId = window.adform_js_params.bidding_id;
  if (window.globals.breakpoint <= 'charlie' && window.adform_js_params.bidding_id_charlie) {
    biddingId = window.adform_js_params.bidding_id_charlie;
  }
  if (biddingId) {
    $('head').append(`<script src="//hb.adx.adform.net/hb/${biddingId}.js"></script>`);
  }
}

function setupAdformPlacements() {
  const isDesktop = window.globals.breakpoint >= 'delta';
  $('.adform-placement').each(function() {
    const $wrapper = $(this);
    const adId = $wrapper.data('adform-id');
    const showAd = isDesktop === $wrapper.hasClass('adform-desktop');
    if (adId && showAd) {
      $wrapper.append(`<script data-adfscript="adx.adform.net/adx/?mid=${adId}"></script><script src="//s1.adform.net/banners/scripts/adx.js" async defer></script`);
    }
  });
}

export default function() {
  setupAdformPlacements();
  if (!window.adform_js_params) {
    return;
  }
  setupAdformBidding();
}



// WEBPACK FOOTER //
// ./scripts/components/adform.js